import { messageModalSelect } from '../../../redux/members/selectors';

const map = (state) => ({
  ...messageModalSelect(state),
});

export default map;
